<template>
  <table class="table table-details">
    <tr>
      <td class="text-nowrap"><label>{{ $t('generic.id') }}</label></td>
      <td>
        {{ details.id }}
      </td>
    </tr>
    <tr>
      <td class="text-nowrap"><label>{{ $t('generic.created') }}</label></td>
      <td>{{ details.created_at | time }}</td>
    </tr>
    <tr>
      <td class="text-nowrap"><label>{{ $t('generic.updated') }}</label></td>
      <td>{{ details.updated_at | time }}</td>
    </tr>
    <tr>
      <td class="text-nowrap"><label>{{ $t('offlineFilters.details.size') }}</label></td>
      <td>{{ details.size }}</td>
    </tr>
    <tr>
      <td class="text-nowrap"><label>{{ $t('offlineFilters.details.priority') }}</label></td>
      <td>
          {{ details.priority }}
      </td>
    </tr>
    <tr>
      <td class="text-nowrap"><label>{{ $t('offlineFilters.details.filter_action') }}</label></td>
      <td>{{ details.filter_action }}</td>
    </tr>
    <tr>
      <td class="text-nowrap"><label>{{ $t('offlineFilters.details.url') }}</label></td>
      <td class="text-break">{{ details.url }}</td>
    </tr>
    <tr>
      <td class="text-nowrap"><label>{{ $t('generic.type') }}</label></td>
      <td>{{ details.filter_type }}</td>
    </tr>
    <tr>
      <td class="text-nowrap"><label>{{ $t('offlineFilters.details.metadata') }}</label></td>
      <td><meta-data-details :data="details.metadata" /></td>
    </tr>
    <tr>
      <td class="text-nowrap"><label>{{ $t('offlineFilters.details.template_type') }}</label></td>
      <td>{{ details.template_type }}</td>
    </tr>
    <tr>
      <td class="text-nowrap"><label>{{ $t('offlineFilters.details.template_variables') }}</label></td>
      <td><meta-data-details :data="details.template_variables" /></td>
    </tr>
    <tr>
      <td class="text-nowrap"><label>{{ $t('offlineFilters.details.not_after') }}</label></td>
      <td>{{ details.not_after | time }}</td>
    </tr>
    <tr>
      <td class="text-nowrap"><label>{{ $t('offlineFilters.details.version') }}</label></td>
      <td>{{ details.version }}</td>
    </tr>
    <tr>
      <td class="text-nowrap"><label>{{ $t('offlineFilters.details.fare_group_id') }}</label></td>
      <td>{{ details.fare_group_id }}</td>
    </tr>
    <tr>
      <td class="text-nowrap"><label>{{ $t('offlineFilters.details.filter_kind') }}</label></td>
      <td>{{ details.filter_kind }}</td>
    </tr>

  </table>
</template>
<script>
import MetaDataDetails from "src/components/MetaData/MetaDataDetails";

export default {
  name: 'OfflineFilterDetails',
  components: {
    MetaDataDetails
  },
  props: {
    details: {
      type: Object,
      required: true,
    },
  },
};
</script>
